import { Language } from "../../data/constants";
import { TranslationKey } from "../../translations/TranslationKey";
import { ExamType } from "../Exam";

export enum ExamSessionCandidateExamState {
  Booked = "Booked",
  Cancelled = "Cancelled",
  Passed = "Passed",
  Failed = "Failed",
  Equivalence = "Equivalence",
}

export const ExamSessionCandidateExamStateTranslationKey: {
  [examState in ExamSessionCandidateExamState]: TranslationKey;
} = {
  [ExamSessionCandidateExamState.Booked]: "examSessionCandidateExamState.booked",
  [ExamSessionCandidateExamState.Cancelled]: "examSessionCandidateExamState.cancelled",
  [ExamSessionCandidateExamState.Passed]: "examSessionCandidateExamState.passed",
  [ExamSessionCandidateExamState.Failed]: "examSessionCandidateExamState.failed",
  [ExamSessionCandidateExamState.Equivalence]: "examSessionCandidateExamState.equivalence",
};

export interface ExamSessionCandidateExamViewModel {
  moduleId: string;
  examId: string;
  type: ExamType;
  examDayId: string;
  roomId: string;
  timeSlotIndex: number;
  grade?: number | null;
  score?: number | null;
  state: ExamSessionCandidateExamState;
  isManualState: boolean;
  willBeRefunded: boolean;
  comment: string;
  refundAccountNumber: string;
  caseName?: string;
  language?: Language;
}
